import { agentDisplayName, agentInitial, agentTone, type AgentIdentity, type AgentTone } from '../utils/agentLabels';
import styles from './AgentChip.module.css';

const TONE_CLASS: Record<AgentTone, string> = {
  accent: styles.toneAccent,
  info: styles.toneInfo,
  purple: styles.tonePurple,
  neutral: styles.toneNeutral,
};

/**
 * Which agent a task belongs to, at a glance: the agent's initial in its own colour, plus the name
 * unless the caller asks for the compact form. Driven by the task's stamped `agentType`, never by a
 * skill name.
 */
export function AgentChip({
  agentType,
  agents,
  compact = false,
}: {
  agentType: string | null | undefined;
  agents?: readonly AgentIdentity[];
  compact?: boolean;
}) {
  const name = agentDisplayName(agentType, agents);
  return (
    <span
      className={`${styles.chip} ${TONE_CLASS[agentTone(agentType)]}`}
      title={name}
      aria-label={`Agent: ${name}`}
    >
      <span className={styles.initial} aria-hidden>
        {agentInitial(name)}
      </span>
      {!compact && <span className={styles.name}>{name}</span>}
    </span>
  );
}
